import {
    setCustomValidator,
    ExtendedFieldId,
    ExtendedErrorId,
    Validator,
    FieldContent
} from '@sheerid/jslib';


export const jobTitleValidator = () => {
    const jobTitle: ExtendedFieldId = 'jobTitle';

    const getJobTitleValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'invalidJobTitle';

        if (!value) {
            return invalidError;
        }

        return;
    };

    setCustomValidator(jobTitle, getJobTitleValidationError);
};

export const ruleOptInValidator = () => {
    const ruleOptIn: ExtendedFieldId = 'ruleOptIn';

    const getRuleOpInValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'invalidRuleOptIn';

        if (!value) {
            return invalidError;
        }

        return;
    };

    setCustomValidator(ruleOptIn, getRuleOpInValidationError);
};

export const optInValidationError = (isRequired: boolean) => {
    const ruleOptIn: ExtendedFieldId = 'marketConsentValue';

    const getOptInValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'marketConsentRequired';
        if (isRequired && !value) {
            return invalidError;
        }
        return;
    };

    setCustomValidator(ruleOptIn, getOptInValidationError);
}
